import { ReactElement } from 'react'
import { ClickAwayListener, Tooltip, TooltipProps, useTheme } from '@mui/material'

interface IPlainTooltipProps extends TooltipProps {
  onClose: () => void
  children: ReactElement
}

const PlainTooltip = (props: IPlainTooltipProps) => {
  const { onClose, children, slotProps, ...rest } = props
  const theme = useTheme()

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Tooltip
        {...rest}
        disableFocusListener={true}
        disableHoverListener={true}
        disableTouchListener={true}
        slotProps={{
          ...slotProps,
          popper: {
            ...slotProps?.popper,
            disablePortal: true,
          },
          tooltip: {
            sx: {
              backgroundColor: theme.palette.ui.inverseSurface,
              color: theme.palette.ui.inverseOnSurface,
            },
          },
        }}
      >
        {children}
      </Tooltip>
    </ClickAwayListener>
  )
}

export default PlainTooltip
